import Grid from '@mui/material/Grid';
import { FormattedMessage } from 'react-intl';
import Button from '../Button';
import Modal from '../Modal';

// todo This can be used for the onBeforeUnload callback (handled by history.block())
//
//      Im not sure if we can customise the look and feel of the confirm dialog box. Like google chrome,
//      we cant change the text, instead it uses its default text. Check this video link:
//      https://caniuse.com/?search=beforeunload.
//
// export const unsavedChangesDialogLabel = defineMessage({
//     id: 'components.UnsavedChangesDialogBox.label',
//     defaultMessage:
//         'You have unsaved changes. Are you sure you want to leave the page?',
// });

export default function UnsavedChangesDialogBox({
    isOpen,
    onGoBack,
    onContinue,
}: {
    isOpen: boolean;
    onGoBack: () => void;
    onContinue: () => void;
}) {
    return (
        <Modal
            open={isOpen}
            header={{
                title: (
                    <FormattedMessage defaultMessage="You have unsaved changes." />
                ),
            }}
            closeModal={onGoBack}
        >
            <Grid
                container
                // TODO: For smaller device, the width must be 100%
                style={{ width: '75%', margin: '0 auto' }}
                justifyContent="space-between"
            >
                <Grid item>
                    <Button variant="text" onClick={onGoBack}>
                        <FormattedMessage defaultMessage="Go back" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button variant="text" onClick={onContinue}>
                        <FormattedMessage defaultMessage="Continue without saving" />
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
}
